import Constants from "./Constants";
import PortugueseStrings from "./PortugueseStrings";
import EnglishStrings from "./EnglishStrings";
import SpanishStrings from "./SpanishStrings";

const language = localStorage.getItem(Constants.LOCAL_STORAGE_KEY);

const Strings = language === Constants.EN_LANG_KEY
  ? EnglishStrings
  : language === Constants.ES_LANG_KEY
    ? SpanishStrings
    : PortugueseStrings;

export default Strings;
